var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('load-content',{attrs:{"loading":!_vm.isReady}},[(_vm.isReady)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }